export type PlanScale = '1:1' | '1:50' | '1:100' | '1:200' | '1:250' | '1:500';
export default PlanScale;

export const PlanScales: PlanScale[] = ['1:1', '1:50', '1:100', '1:200', '1:250', '1:500'];